import { Container, Sprite, Texture, Graphics, Text } from 'pixi.js';
import { EVENTS } from '../lib/constants';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { Tween, Easing } from '@tweenjs/tween.js';
import { ReelConfig } from '../lib/globals/ReelConfigs';
import { ReelConfigMobile } from '../lib/globals/ReelConfigsMobile';
import {
	formatCurrencyValue,
	getCurrencySymbol
} from '../controllers/helper/currencies';
import { isDesktop } from 'react-device-detect';

class CoeffsView extends Container {
	currentPanel = null;
	currentCoeffs = [];
	currentAmounts = [];
	iconWidth = 0;
	iconHeight = 0;
	reels = null;
	lines = null;
	inputData = null;
	panelOpenTweener = null;
	clickTimeout = null;
	clickLock = false;
	reelActive = false;

	constructor(_reels, _lines) {
		super();
		window.addEventListener(EVENTS.ICON_CLICKED, this, false);
		window.addEventListener(EVENTS.BET_UPDATE, this, false);
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.REEL_STARTED, this, false);
		window.addEventListener(EVENTS.REEL_FINISHED, this, false);
		window.addEventListener(
			EVENTS.INTERACTION,
			this.handleClickOutside.bind(this)
		);
		this.reels = _reels;
		this.lines = _lines;
		this.icon = null;
		if (window.isMobile) {
			this.iconWidth = ReelConfigMobile.iconWidth;
			this.iconHeight = ReelConfigMobile.iconHeight;
		} else {
			this.iconWidth = ReelConfig.iconWidth;
			this.iconHeight = ReelConfig.iconHeight;
		}
	}

	handleClickOutside(evt) {
		if (this.clickLock) {
			return;
		}
		this.removeCurrentPanel();
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.REEL_FINISHED:
				this.reelActive = false;
				break;
			case EVENTS.REEL_STARTED:
				this.reelActive = true;
				this.removeCurrentPanel();
				break;
			case EVENTS.MODAL:
				if (evt.detail.modal !== '') {
					this.removeCurrentPanel();
				}
				break;
			case EVENTS.ICON_CLICKED:
				if (
					GameConfigs.bonusBuy ||
					this.reelActive ||
					GameConfigs.modal !== ''
				) {
					return;
				}
				this.lines.fastStop();
				this.clickLock = true;
				setTimeout(() => {
					this.clickLock = false;
				}, 100);
				if (GameConfigs.settings.game_animation) {
					if (evt.detail.icon.fg && evt.detail.icon.fg.gotoAndPlay) {
						evt.detail.icon.fg.gotoAndPlay(0);
					}
					if (evt.detail.icon.fg2 && evt.detail.icon.fg2.gotoAndPlay) {
						evt.detail.icon.fg2.gotoAndPlay(0);
						this.icon = evt.detail.icon;
					}
					if (evt.detail.icon.fg2 && evt.detail.icon.fg2.animate) {
						evt.detail.icon.fg2.animate();
					}
				}
				this.createIcon(evt.detail.id, evt.detail.reel_position);
				break;
			case EVENTS.BET_UPDATE:
				this.clickLock = true;
				setTimeout(() => {
					this.clickLock = false;
				}, 100);
				this.updateAmounts(evt.detail.betAmount);
				break;
			default:
				break;
		}
	}

	removeCurrentPanel() {
		if (this.currentPanel === null) {
			return;
		}
		for (let i = 0; i < this.reels.length; i++) {
			const reel = this.reels[i];
			for (let k = 0; k < reel.items.length; k++) {
				const item = reel.items[k];
				item.alpha = 1;
			}
		}
		if (this.panelOpenTweener !== null) {
			this.panelOpenTweener.stop();
			this.panelOpenTweener = null;
		}
		let cPanel = this.currentPanel;
		cPanel.inputData = this.inputData;

		new Tween(cPanel)
			.to({ alpha: 0 }, 100)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				if (cPanel.parent) {
					cPanel.parent.removeChild(cPanel);
					if (this.inputData !== null) {
						if (
							cPanel.inputData.id === this.inputData.id &&
							cPanel.inputData.reel_position.col ===
								this.inputData.reel_position.col &&
							cPanel.inputData.reel_position.row ===
								this.inputData.reel_position.row
						) {
							this.inputData = null;
							if (this.icon && this.icon.fg2 && this.icon.fg2.gotoAndPlay) {
								this.icon.fg2.gotoAndStop(0);
							}
						}
					}
				}
			})
			.start();
	}

	createIcon(id, reel_position) {
		if (this.inputData !== null) {
			if (
				this.inputData.id === id &&
				this.inputData.reel_position.col === reel_position.col &&
				this.inputData.reel_position.row === reel_position.row
			) {
				this.removeCurrentPanel();
				this.inputData = null;
				return;
			}
		}

		this.inputData = {
			id: id,
			reel_position: reel_position
		};
		if (this.currentPanel !== null) {
			this.removeCurrentPanel();
		}

		for (let i = 0; i < this.reels.length; i++) {
			const reel = this.reels[i];
			for (let k = 0; k < reel.items.length; k++) {
				const item = reel.items[k];
				if (i === reel_position.col && k === reel_position.row) {
					item.alpha = 1;
				} else {
					item.alpha = 0.4;
				}
			}
		}
		let coeffs = this.getItemCoeffs(id);
		if (coeffs !== null) {
			this.currentAmounts = [];

			for (let index = 0; index < coeffs.length; index++) {
				const element = coeffs[index];
				if (element > 0) {
					this.currentAmounts.unshift({
						mult: index + 1,
						amount: element
					});
				}
			}
			if (this.currentAmounts.length > 0) {
				this.currentCoeffs = coeffs;
				this.currentPanel = this.buildIcon(reel_position.col >= 3);
				let panelX = 0;
				if (this.currentPanel.isLeft) {
					this.currentPanel.border_l.anchor.set(0, 1);
					this.currentPanel.border_l.y =
						this.currentPanel.border_l.getBounds().height / 2;
					panelX = this.iconWidth * reel_position.col - 10;
					this.currentPanel.x = this.iconWidth * reel_position.col - 50;
					this.currentPanel.y =
						this.iconHeight * reel_position.row + this.iconHeight / 2;
					// this.currentPanel.border_l.rotation = 3.14;
					this.currentPanel.border_l.y =
						this.currentPanel.border_l.getBounds().height / 2;
				} else {
					this.currentPanel.border_r.anchor.set(0, 1);
					this.currentPanel.border_r.y =
						this.currentPanel.border_r.getBounds().height / 2;
					panelX = this.iconWidth * (reel_position.col + 1) - 5;
					this.currentPanel.x = this.iconWidth * (reel_position.col + 1) + 50;
					this.currentPanel.y =
						this.iconHeight * reel_position.row + this.iconHeight / 2;
				}
				this.currentPanel.alpha = 0;
				if (isDesktop) {
					this.currentPanel.scale.set(1);
				} else {
					this.currentPanel.scale.set(0.6);
				}
				this.panelOpenTweener = new Tween(this.currentPanel)
					.to({ alpha: 1, x: panelX }, 300)
					.easing(Easing.Back.Out)
					.onComplete(() => {
						this.panelOpenTweener.stop();
						this.panelOpenTweener = null;
					})
					.start();
				//
				this.updateAmounts(parseFloat(GameConfigs.currentBet));
				this.addChild(this.currentPanel);
			}
		}
	}

	updateAmounts(currentBet) {
		if (this.currentPanel === null) {
			return;
		}
		if (this.currentPanel.texts) {
			this.currentPanel.removeChild(this.currentPanel.texts);
		}
		if (this.currentPanel.maskGraphics) {
			this.currentPanel.removeChild(this.currentPanel.maskGraphics);
		}
		this.currentPanel.texts = this.createTexts(currentBet);
		let textSize = this.currentPanel.texts.getBounds();
		if (this.currentPanel.isLeft) {
			this.currentPanel.texts.y = -textSize.height / 2;
			this.currentPanel.texts.x = -textSize.width - 60;

			this.currentPanel.maskGraphics = new Graphics();
			this.currentPanel.maskGraphics.clear();
			this.currentPanel.maskGraphics.beginFill(0xffffff, 0.2);
			this.currentPanel.maskGraphics.drawRoundedRect(
				-(100 + textSize.width),
				-this.currentPanel.bg.height / 2,
				120 + textSize.width,
				this.currentPanel.bg.height,
				0
			);
			this.currentPanel.maskGraphics.endFill();
			this.currentPanel.bg.mask = this.currentPanel.maskGraphics;
			this.currentPanel.addChild(this.currentPanel.maskGraphics);
			this.currentPanel.border_l.x = -(115 + textSize.width);
		} else {
			this.currentPanel.texts.y = -textSize.height / 2;
			this.currentPanel.texts.x = 60;
			this.currentPanel.maskGraphics = new Graphics();
			this.currentPanel.maskGraphics.clear();
			this.currentPanel.maskGraphics.beginFill(0xffffff, 0.2);
			this.currentPanel.maskGraphics.drawRoundedRect(
				0,
				-this.currentPanel.bg.height / 2,
				120 + textSize.width,
				this.currentPanel.bg.height,
				0
			);
			this.currentPanel.border_r.x = 120 + textSize.width;

			this.currentPanel.maskGraphics.endFill();
			this.currentPanel.bg.mask = this.currentPanel.maskGraphics;
			this.currentPanel.addChild(this.currentPanel.maskGraphics);
		}

		this.currentPanel.addChild(this.currentPanel.texts);
	}

	createTexts(currentBet) {
		let texts = new Container();
		let currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		let yMult = this.currentAmounts.length > 3 ? 35 : 45;
		let REEL_COEFFS_CNT =
			this.currentAmounts.length > 3
				? window.lm.REEL_COEFFS_CNT_SMALL
				: window.lm.REEL_COEFFS_CNT;
		let REEL_COEFFS_AMT =
			this.currentAmounts.length > 3
				? window.lm.REEL_COEFFS_AMT_SMALL
				: window.lm.REEL_COEFFS_AMT;
		for (let index = 0; index < this.currentAmounts.length; index++) {
			const element = this.currentAmounts[index];
			const mult = element.mult;
			let amount = formatCurrencyValue(
				(element.amount * currentBet) / 10,
				currency
			);
			let multText = new Text(mult, REEL_COEFFS_CNT.config);
			multText.x = 0;
			multText.y = yMult * index;
			texts.addChild(multText);

			let amtText = new Text(amount, REEL_COEFFS_AMT.config);
			amtText.x = 45;
			amtText.y = yMult * index + 1.5;
			texts.addChild(amtText);
		}

		return texts;
	}

	buildIcon(isLeft) {
		//coeffs_right_bg  coeffs_left_bg
		let panel = new Container();
		let bg = null;
		let border_l = null;
		let border_r = null;
		if (isLeft) {
			bg = Sprite.from(Texture.from('coeffs_left_bg'));
			border_l = Sprite.from(Texture.from('coef_line_left'));
			border_l.scale.set(isDesktop ? 1 : 2);
			panel.border_l = border_l;
			panel.addChild(border_l);
			bg.anchor.set(1, 0.5);
		} else {
			bg = Sprite.from(Texture.from('coeffs_right_bg'));
			bg.anchor.set(0, 0.5);
			border_r = Sprite.from(Texture.from('coef_line_right'));
			border_r.scale.set(isDesktop ? 1 : 2);
			panel.border_r = border_r;
			panel.addChild(border_r);
		}
		bg.scale.set(isDesktop ? 1 : 2);
		panel.bg = bg;
		panel.addChild(bg);
		panel.isLeft = isLeft;
		return panel;
	}

	getItemCoeffs(id) {
		for (let index = 0; index < GameConfigs.config.coeffs.length; index++) {
			const element = GameConfigs.config.coeffs[index];
			if (element.id === id) {
				return element.coeffs;
			}
		}
		return null;
	}

	hide() {
		//coeffs_right_bg  coeffs_left_bg
	}
}

export default CoeffsView;
